export default __webpack_public_path__ + "media/1.a92a0.png";